import React, { useEffect, useState } from "react";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { userPackageDetailByUrl } from "../../services/userPackageApiFn";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import NavBar from "../../components/NavBar";
import { Box, Chip, Grid, Typography } from "@mui/material";
import AppFooter from "../../components/footer";
import ProductPageSkeleton from "../../components/skeletons/productDetailSkeleton";
import ImageSwipper from "./Images";
import PackageInfo from "./Detail";
import InfoTabs from "./InfoTabs";
import Included from "./Included";
import { t } from "i18next";

const PackageDetailPage = () => {
  const { url } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [packageDetail, setPackageDetail] = useState(null);


  useEffect(() => {
    if (url) {
      fetchPackageDetail(url);
    }
  }, [url]);

  const fetchPackageDetail = async (value) => {
    try {
      const response = await userPackageDetailByUrl(value);
      if (response.data.status === "success") {
        const data = response.data.data;
        const galleryImages = data.images?.map((image) => ({
          original: image,
          thumbnail: image,
        }));
        setPackageDetail({ ...data, galleryImages });
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <NavBar />

      {isLoading ? (
        <Box margintop={10} mt={18}>
          <ProductPageSkeleton />
        </Box>
      ) : (
        <>
          {/* Hero Section */}
          <Box mt={16} mb={4}>
            <Box
              height="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography
                variant="heading_pr"
                component="h1"
                textAlign="center"
                lineHeight="normal"
                margin="auto"
                fontSize={{ xs: "1.75rem", sm: "2rem" }}
                textTransform={"capitalize"}
              >
                {t("getBestCustomPackage")}
              </Typography>
            </Box>
          </Box>

          {/* Main Content Section */}
          <Box
            sx={{
              px: 3,
              py: 5,
              backgroundColor: "text.white",
              borderRadius: 3,
              position: "relative",
              top: "-10px",
              maxWidth: "1300px",
              margin: "auto",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {packageDetail?.galleryImages?.length > 0 && (
                  <ImageSwipper galleryImages={packageDetail?.galleryImages} />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <PackageInfo packageDetail={packageDetail} />
              </Grid>
            </Grid>

            <InfoTabs packageDetail={packageDetail} />

            <Included products={packageDetail?.products} />
          </Box>

          <AppFooter bgcolor />
        </>
      )}
      <Chip
        label={t("goBack")}
        onClick={() => navigate(-1)}
        sx={{
          position: "fixed",
          bottom: 15,
          left: 10,
          zIndex: 100000,
          color: "common.white",
          backgroundColor: "primary.main",
          "&:hover": {
            backgroundColor: "primary.main",
          },
        }}
      />
    </>
  );
};

export default PackageDetailPage;
